import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CallsService {
  private _callsapiUrl = `${environment.calltracker}`;

  constructor(private _http: HttpClient) { }

  getCallsData(pageNo: any, pageSize: any, token: any, searchKeyword: string, filters: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10,
      search: searchKeyword || "",
      filters: filters
    }
    return this._http.post<any>(`${this._callsapiUrl}/GetCallsData`, paginationSettings);
  }

  getCallsOfLeads(leadId:any, pageNo: any, pageSize: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 10
    }
    return this._http.post<any>(`${this._callsapiUrl}/getleadcalls/${leadId}`, paginationSettings);
  }
}
